import { render, staticRenderFns } from "./DeliverySchool.vue?vue&type=template&id=0da74d10&scoped=true"
import script from "./DeliverySchool.vue?vue&type=script&lang=ts"
export * from "./DeliverySchool.vue?vue&type=script&lang=ts"
import style0 from "./DeliverySchool.vue?vue&type=style&index=0&id=0da74d10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da74d10",
  null
  
)

export default component.exports